export const STARTING_TAB = 'startingTab';
export const WELCOME_TABS = {
  CREATE_ACCOUNT: 0,
  SIGN_IN: 1
};
